import React from "react";
import "./nodata.scss";
import { useTranslation } from "react-i18next";

const NodataFound = () => {
  const { i18n, t } = useTranslation();
  return (
    <div className="no_data_found">
     {t('common.nodatafound')}
    </div>
  );
};

export default NodataFound;
